import { render, staticRenderFns } from "./JobHoldPoints.vue?vue&type=template&id=67596a0a&"
import script from "./JobHoldPoints.vue?vue&type=script&lang=js&"
export * from "./JobHoldPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports